import { CButton, CCard, CCardBody, CCardFooter, CCardHeader, CForm, CFormGroup, CLink } from '@coreui/react';
import { inject, observer } from 'mobx-react';
import { Component } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { OrmStoreType } from '../core/Stores/DirectoryStore';
import { OrmUserStoreType } from '../core/Stores/OrmUserStore';
import { stringFormatter } from '../shared/Formatters/StringFormatter';
import NatValueInput from '../shared/Inputs/NatValueInput';
import { catalog } from '../shared/support/Catalog';
import { MatchType } from '../shared/support/modelTypes';

interface PropsType extends RouteComponentProps {
	login(): any;
	match: MatchType;
}
interface InjectedProps extends PropsType {
	userStore: OrmUserStoreType;
	directoryStore: OrmStoreType;
}

@inject('userStore', 'directoryStore')
@observer
class UserLogin extends Component<PropsType> {
	constructor(props: PropsType) {
		super(props);
		this.submit = this.submit.bind(this);
		this.chooseValidInput = this.chooseValidInput.bind(this);
	}
	get injected() {
		return this.props as InjectedProps;
	}
	componentDidMount() {
		document.title = 'Логин';
	}
	submit(e: any) {
		e.preventDefault();
		let form = e.target.form;
		let inputs = form.querySelectorAll('input');
		inputs.forEach((item: any) => {
			item.focus();
			item.blur();
		});
		return this.props.login();
	}
	chooseValidInput() {
		let inputs = {
			master: (
				<NatValueInput<string> object={this.injected.userStore.userLogin} property="email" placeholder="Введите почту" type="email" formatter={stringFormatter(true)} size="lg" autoComplete="off" useHandleEnter={false} label="Почта" loginInput />
			),
			tenant: <NatValueInput<string> object={this.injected.userStore.userLogin} property="login" placeholder="Введите логин" type="text" formatter={stringFormatter(true)} size="lg" autoComplete="off" useHandleEnter={false} label="Логин" loginInput />
		};
		if (this.injected.directoryStore.models.apiData.mode) {
			return inputs[this.injected.directoryStore.models.apiData.mode];
		} else {
			return inputs['master'];
		}
	}
	render() {
		return (
			<div className="justify-content-center align-items-center c-app nat__gardient__bg overflow-auto">
				<CCard className="d-flex flex-column align-items-center nat__login nat__card__wrapper nat__borders__2-75">
					<CCardHeader className="border-0 font-weight-bold bg-transparent">
						<h4 className="m-0">Авторизируйтесь!</h4>
					</CCardHeader>
					<CCardBody className="mx-4 pb-0">
						<CForm className="">
							{this.chooseValidInput()}
							<NatValueInput<string>
								object={this.injected.userStore.userLogin}
								property="password"
								placeholder="Ввведите пароль"
								type="password"
								formatter={stringFormatter(true)}
								size="lg"
								autoComplete="off"
								useHandleEnter={false}
								label="Пароль"
								loginInput
							/>
							<CFormGroup className="form-actions d-flex flex-column my-4">
								<CButton
									type="submit"
									size="lg"
									className="nat__button"
									onClick={(e) => {
										this.submit(e)
											.then(() => {
												if (this.injected.userStore.redirect) {
													window.location.href = this.injected.userStore.redirect;
												} else {
													window.location.reload();
												}
											})
											.catch((error) => {
												catalog.handleNatError(error);
											});
									}}>
									Войти
								</CButton>
							</CFormGroup>
						</CForm>
					</CCardBody>
					<CCardFooter className="d-flex flex-column border-0 bg-transparent pt-0">
						{this.injected.directoryStore.models.apiData.mode === 'tenant' && (
							<div>
								{'Еще нет учетной записи? '}
								<CLink to="/users/registration">Регистрация</CLink>
							</div>
						)}
						<CLink to="/users/resetPassword">Забыли пароль?</CLink>
					</CCardFooter>
				</CCard>
			</div>
		);
	}
}

export default withRouter(UserLogin);
